// 'YYYY-MM-DD' → 'dd/MM' sem passar por Date(): o dia já vem no fuso da conta, e
// um parse aqui o jogaria para o dia anterior em UTC-3.
export const dayLabel = isoDay => {
  const [, month, day] = isoDay.split('-');
  return `${day}/${month}`;
};

const nextDay = isoDay => {
  const date = new Date(`${isoDay}T00:00:00Z`);
  date.setUTCDate(date.getUTCDate() + 1);
  return date.toISOString().slice(0, 10);
};

// Um dia sem linha na resposta é um dia sem movimento: o gráfico precisa dele como
// zero, ou a janela encolhe e dois dias distantes aparecem lado a lado.
export const fillDays = (rows, since, until, empty) => {
  if (!since || !until) return rows;
  const byDay = new Map(rows.map(row => [row.day, row]));
  const days = [];
  for (let day = since; day <= until; day = nextDay(day)) {
    days.push(byDay.get(day) || { day, ...empty });
  }
  return days;
};
